import React from "react";
import { Tooltip } from "@mui/material";
import {
  TopicChipButton,
  TopicChipTooltipTitle,
  TopicChipTooltipDesc,
} from "./style.js";

const tooltipSx = {
  color: "#02002B",
  background: "#D1C7FF",
  maxWidth: 220,
  "& span:before": { background: "#D1C7FF" },
};

const TopicChip = ({ topic }) => (
  <Tooltip
    title={
      topic.description ? (
        <>
          <TopicChipTooltipTitle>{topic.name}</TopicChipTooltipTitle>
          <TopicChipTooltipDesc>{topic.description}</TopicChipTooltipDesc>
        </>
      ) : (
        ""
      )
    }
    placement="top"
    arrow
    slotProps={{ tooltip: { sx: tooltipSx } }}
  >
    <TopicChipButton>{topic.name}</TopicChipButton>
  </Tooltip>
);

export default TopicChip;
